/* eslint-disable css-modules/no-unused-class, no-extra-boolean-cast  */
import { FC } from 'react';
import { translate } from 'translations';
import OverallAchievements from './overall/overallAchievements';
import HomePageBanners from './homePageBanners/homePageBanners';
import AssessmentsResults from './assessmentsResults/assessmentsResults';
import styles from './assessmentPage.module.scss';
import { ResultsCardProps } from './resultsCard/resultsCard';
import { AssessmentBannerProps } from './banner/assessmentBanner';

const AssessmentPage: FC<AssessmentPageProps> = (props: AssessmentPageProps) => {
    const {
        newAssessments,
        overallAchievements,
        assessmentsResults,
        isAssessmentResultsLoading,
        isUncompletedAssessmentsLoading
    } = props;

    return (
        <>
            <div id="test-page" className={styles['assessments-wrapper']}>
                {newAssessments.length > 0 ? (
                    <>
                        <div className={styles['section-title']}>
                            {translate('NewAssessments(x)', { x: String(newAssessments.length) })}
                        </div>
                        <HomePageBanners
                            assessments={newAssessments}
                            upComingTournaments={[]}
                            learningPaths={[]}
                            skillTreeBanner={[]}
                            videoTutorialsBanner={[]}
                            courseBanner={[]}
                            lessonsBanner={[]}
                            labBanner={[]}
                        />
                    </>
                ) : (
                    <div></div>
                )}

                {overallAchievements ? (
                    <>
                        <div className={styles['section-title']}>{translate('OverallAchievements')}</div>
                        <OverallAchievements {...overallAchievements} />
                    </>
                ) : (
                    <div></div>
                )}

                {assessmentsResults && !isAssessmentResultsLoading && (
                    <>
                        <div className={styles['section-title']}>
                            {translate('AssessmentsResults(x)', { x: String(assessmentsResults.length) })}
                        </div>
                        <AssessmentsResults
                            assessmentsResults={assessmentsResults}
                            isEmpty={!Boolean(assessmentsResults.length) && !isAssessmentResultsLoading}
                        />
                    </>
                )}
            </div>
        </>
    );
};

interface AssessmentPageProps {
    newAssessments: AssessmentBannerProps[];
    overallAchievements: OverallAchievements | undefined;
    assessmentsResults: ResultsCardProps[];
    isAssessmentResultsLoading: boolean;
    isUncompletedAssessmentsLoading: boolean;
}

interface OverallAchievements {
    strongCategories: string[];
    fairCategories: string[];
    poorCategories: string[];
    assessmentsTakenNumber: number;
    overallRating: number;
}
export default AssessmentPage;
